<template>
  <div>
    <hit-miss
      :info-card="computedInfoCard"
      :data="hitMisses"
      :bar-colors="['#619AF8', '#E2875A']"
    />
    <div
      class="my-1 col-lg-12 col-12 d-flex flex-wrap px-0 mx-0"
    >
      <div class="col-lg-6 col-md-6 col-12 pl-0">
        <request-details
          title="Hit Requests"
          name="Hit Requests"
          :request-info="computedHitRequests"
          :bar-colors="['#24CE54','#619AF8','#DBBC1E']"
          :request-details="hitRequestsData"
          :time-stamps="detailTimeStamps"
        />
      </div>
      <div class="col-lg-6 col-md-6 col-12 px-0">
        <request-details
          title="Miss  Requests"
          name="Miss  Requests"
          :request-info="computedMissRequests"
          :bar-colors="['#E96767','#CDCF4B','#5D8DDD','#EBAD8E']"
          :request-details="missRequestsData"
          :time-stamps="detailTimeStamps"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HitMiss from '../widgets/HitMiss.vue'
import RequestDetails from '../widgets/RequestsDetails.vue'

export default {
  components: {
    HitMiss,
    RequestDetails,
  },
  data() {
    return {
      detailTimeStamps: [],
    }
  },
  computed: {
    hitMisses() {
      return this.$store.state.analytics.hitMisses ?? []
    },
    hitMissesDetails() {
      return this.$store.state.analytics.hitMissesDetails ?? []
    },
    hitMissesLoaded() {
      return this.$store.state.analytics.loadingHitMisses
    },
    hitMissesCachedData() {
      return this.$store.state.analytics.hitMissesCachedData
    },
    hitMissesNoCacheData() {
      return this.$store.state.analytics.hitMissesNoCacheData
    },
    computedInfoCard() {
      const infoCard = [
        {
          id: 1,
          title: 'Cached data ratio',
          description: this.hitMissesCachedData.percentValue,
          elipseColor: '#619AF8',
          loading: this.hitMissesLoaded,
        },
        {
          id: 2,
          title: 'Non-Cached data ratio',
          description: this.hitMissesNoCacheData.percentValue,
          elipseColor: '#E2875A',
          loading: this.hitMissesLoaded,
        },
        {
          id: 3,
          title: 'Total traffic',
          description: this.formatNumberWithUnit(this.hitMisses?.total),
          elipseColor: '',
          loading: this.hitMissesLoaded,
        },
      ]
      return infoCard
    },
    computedHitRequests() {
      const hitRequests = [
        {
          id: 1,
          elipseColor: '#24CE54',
          title: `< ${this.calculateDataRatio(this.hitMissesDetails?.total, this.hitRequestsData[0]?.total)} Hit`,
          size: `- ${this.formatNumberWithUnit(this.hitRequestsData[0]?.total)}`,
          description: 'Response contains valid content directly from the cache.',
        },
        {
          id: 2,
          elipseColor: '#619AF8',
          title: `< ${this.calculateDataRatio(this.hitMissesDetails?.total, this.hitRequestsData[1]?.total)} Updating`,
          size: `- ${this.formatNumberWithUnit(this.hitRequestsData[1]?.total)}`,
          description: 'Content is being updated in response to a prevoius request',
        },
        {
          id: 3,
          elipseColor: '#DBBC1E',
          title: `< ${this.calculateDataRatio(this.hitMissesDetails?.total, this.hitRequestsData[1]?.total)} Stale`,
          size: `- ${this.formatNumberWithUnit(this.hitRequestsData[2]?.total)}`,
          description: 'Content is stale because the origin server is not respondingcorrectly. ',
        },
      ]
      return hitRequests
    },
    computedMissRequests() {
      const missRequests = [
        {
          id: 1,
          elipseColor: '#E96767',
          title: `< ${this.calculateDataRatio(this.hitMissesDetails?.total, this.missRequestsData[0]?.total)} Miss`,
          size: `- ${this.formatNumberWithUnit(this.missRequestsData[0]?.total)}`,
          description: 'Response wasn’t found in the cache. The content was fetched from the origin server.',
        },
        {
          id: 2,
          elipseColor: '#CDCF4B',
          title: `< ${this.calculateDataRatio(this.hitMissesDetails?.total, this.missRequestsData[1]?.total)} Expired`,
          size: `- ${this.formatNumberWithUnit(this.missRequestsData[1]?.total)}`,
          description: 'Entry in the cache has expired. The content was fetched from the origin server.',
        },
        {
          id: 3,
          elipseColor: '#5D8DDD',
          title: `< ${this.calculateDataRatio(this.hitMissesDetails?.total, this.missRequestsData[2]?.total)} Other`,
          size: `- ${this.formatNumberWithUnit(this.missRequestsData[2]?.total)}`,
          description: 'Response contains fresh content from the origin server.',
        },
        {
          id: 4,
          elipseColor: '#EBAD8E',
          title: `< ${this.calculateDataRatio(this.hitMissesDetails?.total, this.missRequestsData[3]?.total)} Empty`,
          size: `- ${this.formatNumberWithUnit(this.missRequestsData[3]?.total)}`,
          description: 'Errors, bad requests, redirects. The cache status is by definition invalid. ',
        },
      ]
      return missRequests
    },
    hitRequestsData() {
      const names = ['hit', 'stale', 'updating']
      const { hitMissesDetails } = this
      if (hitMissesDetails && hitMissesDetails.result) {
        return this.getDataByNamesAndData(hitMissesDetails.result, names) ?? []
      }
      return []
    },
    missRequestsData() {
      const names = ['miss', 'expired', 'other', 'empty']
      const { hitMissesDetails } = this
      if (hitMissesDetails && hitMissesDetails.result) {
        return this.getDataByNamesAndData(hitMissesDetails.result, names)
      }
      return []
    },
  },
  methods: {
    getDataByNamesAndData(dataList, targetNames) {
      const result = dataList?.filter(item => targetNames?.includes(item.name))
        .map(item => ({
          name: item.name[0].toUpperCase() + item.name.slice(1),
          data: item?.data?.map(data => data.value),
          total: item?.total,
        }))
      this.detailTimeStamps = dataList?.flatMap(item => item?.data?.map(data => data.timestamp)) || []
      return result
    },
  },
}
</script>
